import type { ReactNode } from 'react'
import { Navigate } from 'react-router'
import { useOAuth } from '../providers/OAuthProvider'

export function RequireOAuthParams({ children }: { children: ReactNode }) {
	const { params } = useOAuth()
	if (!params) return <Navigate to="/authorize" replace />
	return children
}
